<!-- 维护课程 -->
<template>
    <el-dialog :title="isedit ? '编辑课程' : '新增课程'" :visible.sync="dialogVisible" :before-close="handleClose" custom-class="dialogForm" class="measDialog maintainCourse" width="80%" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-scrollbar class="dialogContentScroll" v-loading="contentLoading">
            <el-form :model="params" :rules="rules" ref="maintainCourse">
                <div class="moduleTitle">基本信息</div>
                <el-form-item label="课程名称" prop="name">
                    <el-input v-model="params.name" maxlength="50" show-word-limit placeholder="请输入课程名称"></el-input>
                </el-form-item>
                <el-form-item label="课时数" prop="periodcount">
                    <el-input v-model="params.periodcount" placeholder="请输入课时数"></el-input>
                </el-form-item>
                <el-form-item label="所属类目">
                    <el-input v-model="params.catename" placeholder="请输入所属类目"></el-input>
                </el-form-item>
                <el-form-item label="课程简介">
                    <el-input v-model="params.summary" maxlength="100" show-word-limit type="textarea" placeholder="请输入课程简介"></el-input>
                </el-form-item>
                <el-form-item label="封面图片" prop="coveratturls">
                    <div class="tips">建议尺寸 750*420px 或者 16:9，JPG、PNG 格式， 图片小于 5M。</div>
                    <div class="uploadItemBox">
                        <div class="uploadItem" v-for="(item, index) in coverattArr" :key="index">
                            <UploadFile v-if="dialogVisible" :ref="'uploadFile' + index" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="coverattUploadSuccess">
                                <div @click="changeCoverattArr(index)">
                                    <div class="noCoveratturl" v-if="!item.coveratturl">
                                        <i class="el-icon-plus"></i>
                                        <div class="label">上传图片</div>
                                    </div>
                                    <div v-else class="coveratturlBox">
                                        <img class="coveratturl" :src="item.coveratturl + '?v=' + now" alt="" />
                                        <div class="coverHandleBox">
                                            <i class="el-icon-back" title="左移" @click.stop="handleMoveCover(index, 'left')" v-if="index !== 0"></i>
                                            <i class="el-icon-delete" title="删除" @click.stop="handleDeleteCover(index)"></i>
                                            <i class="el-icon-right" title="右移" @click.stop="handleMoveCover(index, 'right')" v-if="index !== coverattArr.length - 1"></i>
                                        </div>
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                        <!-- <div class="uploadItem">
                            <UploadFile v-if="dialogVisible" ref="uploadFile1" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="coveratt2UploadSuccess">
                                <div class="noCoveratturl" v-if="!coveratt2.coveratturl">
                                    <i class="el-icon-plus"></i>
                                    <div class="label">上传图片</div>
                                </div>
                                <div v-else class="coveratturlBox">
                                    <img class="coveratturl" :src="coveratt2.coveratturl + '?v=' + now" alt="" />
                                    <div class="coverHandleBox">
                                        <i class="el-icon-back"></i>
                                        <i class="el-icon-delete"></i>
                                        <i class="el-icon-right"></i>
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                        <div class="uploadItem">
                            <UploadFile v-if="dialogVisible" ref="uploadFile1" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="coveratt3UploadSuccess">
                                <div class="noCoveratturl" v-if="!coveratt3.coveratturl">
                                    <i class="el-icon-plus"></i>
                                    <div class="label">上传图片</div>
                                </div>
                                <div v-else class="coveratturlBox">
                                    <img class="coveratturl" :src="coveratt3.coveratturl + '?v=' + now" alt="" />
                                    <div class="coverHandleBox">
                                        <i class="el-icon-back"></i>
                                        <i class="el-icon-delete"></i>
                                        <i class="el-icon-right"></i>
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                        <div class="uploadItem">
                            <UploadFile v-if="dialogVisible" ref="uploadFile1" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="coveratt4UploadSuccess">
                                <div class="noCoveratturl" v-if="!coveratt4.coveratturl">
                                    <i class="el-icon-plus"></i>
                                    <div class="label">上传图片</div>
                                </div>
                                <div v-else class="coveratturlBox">
                                    <img class="coveratturl" :src="coveratt4.coveratturl + '?v=' + now" alt="" />
                                    <div class="coverHandleBox">
                                        <i class="el-icon-back"></i>
                                        <i class="el-icon-delete"></i>
                                        <i class="el-icon-right"></i>
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                        <div class="uploadItem">
                            <UploadFile v-if="dialogVisible" ref="uploadFile1" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="coveratt5UploadSuccess">
                                <div class="noCoveratturl" v-if="!coveratt5.coveratturl">
                                    <i class="el-icon-plus"></i>
                                    <div class="label">上传图片</div>
                                </div>
                                <div v-else class="coveratturlBox">
                                    <img class="coveratturl" :src="coveratt5.coveratturl + '?v=' + now" alt="" />
                                    <div class="coverHandleBox">
                                        <i class="el-icon-back"></i>
                                        <i class="el-icon-delete"></i>
                                        <i class="el-icon-right"></i>
                                    </div>
                                </div>
                            </UploadFile>
                        </div> -->
                    </div>
                    <div class="countTips">最多上传 5 个，至少上传 1 个</div>
                </el-form-item>
                <el-form-item label="授课老师">
                    <SelectPage v-if="dialogVisible" @changePageGetList="changeTeacherListPage" @getSelectValue="getSelectTeacher" :list="teacherList" :initData="initTeacherSelect" label="name" value="code" placeholder="请选择授课老师" :listLoading="teacherListLoading" :isMultiple="true" :paginationOption="teacherPaginationOption" />
                    <!-- <el-select v-model="params.teacher" filterable multiple placeholder="请选择授课老师">
                        <el-option v-for="item in teacherList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="课程详情">
                    <UEditor :content="params.content" ref="uEditor" @getUEditorContent="getUEditorContent" />
                </el-form-item>
                <div class="moduleTitle mt-30">课程设置</div>
                <div class="otherItemBox">
                    <div class="otherItem">
                        <div class="label">
                            防录屏跑马灯
                            <el-tooltip class="item" effect="dark" content="开启后，将显示防录屏跑马灯，您可以根据需要去设置参数全屏播放时，会导致跑马灯失效。" placement="bottom-start">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <el-radio-group v-model="params.ispreventrecording">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="0">关闭</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="otherItem">
                        <div class="label">
                            版权声明
                            <el-tooltip class="item" effect="dark" content="每次播放时，将于屏幕顶部滚动出现一次。展示内容：本课程版权归【资鲸课堂】所有，禁止录制、传播或分享账号，违者将被追究法律责任。" placement="bottom-start">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <el-radio-group v-model="params.iscopyright">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="0">关闭</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="otherItem">
                        <div class="label">
                            是否支持快进
                            <el-tooltip class="item" effect="dark" content="设置学员第一次观看的时候是否可以快进。" placement="bottom-start">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <el-radio-group v-model="params.isspeedplay">
                            <el-radio :label="1">开启</el-radio>
                            <el-radio :label="0">关闭</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </el-form>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel" :disabled="submitDataIng" @click="handleClose">取消</el-button>
            <el-button type="hollowOut" @click="saveCourse(0)" :loading="loading1" :disabled="loading2" v-if="params.status === 0 || !params.code">保存为草稿</el-button>
            <el-button type="primary" @click="saveCourse(1)" :loading="loading2" :disabled="loading1">保存并发布</el-button>
        </span>
    </el-dialog>
</template>

<script>
import UploadFile from '@/components/measComponents/uploadFile/uploadFile.vue'
import UEditor from '@/components/measComponents/uEditor/uEditor.vue'
import SelectPage from '@/components/measComponents/selectPage/selectPage.vue'
import {getCourseTeachListBySelect} from '@/api/measApi/common.js'
import {saveCourse, getCourseDetails} from '@/api/measApi/courseManage.js'
export default {
    data() {
        return {
            isedit: false,
            dialogVisible: false,
            params: {
                classcode: '', // 班级code
                code: '', // 目标code
                catecode: '', // 课程配置code
                catename: '', // 课程配置名
                summary: '', // 说明
                name: '', // 课程名称
                periodcount: '', // 课时数
                teachercode: '', // 老师code
                teachername: '', // 老师名称
                content: '', // 课程详情 html
                coverattids: '', // 封面id
                coveratturls: '', // 封面url
                ispreventrecording: 1, // 防录屏跑马灯
                iscopyright: 1, // 版权声明
                isspeedplay: 0, // 是否快进倍数
                savetype: '', // 0草稿 1保存并提交
                status: '' // 状态：0草稿 10正常 11暂停 30已结业 100已删除
            },
            teacherList: [],
            contentLoading: false,
            loading1: false,
            loading2: false,
            submitDataIng: false,
            rules: {
                name: [
                    {required: true, message: '请输入课程名称', trigger: ['blur', 'change']}
                ],
                periodcount: [
                    {required: true, message: '请输入课时数', trigger: ['blur', 'change']}
                ],
                // courseconfigname: [
                //     {required: true, message: '请输入所属类目', trigger: ['blur', 'change']}
                // ]
                coveratturl: [
                    {required: true, message: '请选择封面图', trigger: ['blur', 'change']}
                ]
            },
            coverattArr: [
                {
                    coverattid: '',
                    coveratturl: ''
                },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // }
            ],
            changeCoverattArrIndex: '',
            uploadType: {
                catecode: '106',
                datatype: 'IMAGE',
                filekeyid: '',
                filesuffix: ''
            },
            now: new Date().getTime(),
            teacherPaginationOption: {
                pagesize: 5,
                page: 1,
                total: 0
            },
            teacherListLoading: false,
            initTeacherSelect: []
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(code) {
            this.dialogVisible = true
            this.getCourseTeachListBySelect()
            if (code) {
                this.params.code = code
                this.isedit = true
                this.getCourseDetails()
            } else {
                this.isedit = false
            }
            this.$nextTick(() => {
                this.$refs.maintainCourse.clearValidate()
            })
        },
        handleClose() {
            if (this.submitDataIng) {
                this.$message.warning('提交数据中，请稍等')
                return
            }
            this.dialogVisible = false
            this.contentLoading = false
            this.isedit = false
            this.params.classcode = ''
            this.params.code = ''
            this.params.catecode = ''
            this.params.catename = ''
            this.params.summary = ''
            this.params.name = ''
            this.params.periodcount = ''
            this.params.teachercode = ''
            this.params.teachername = ''
            this.params.content = ''
            this.params.coverattids = ''
            this.params.coveratturls = ''
            this.params.status = ''
            this.params.ispreventrecording = 1
            this.params.iscopyright = 1
            this.params.isspeedplay = 0
            this.coverattArr = [
                {
                    coverattid: '',
                    coveratturl: ''
                },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // },
                // {
                //     coverattid: '',
                //     coveratturl: ''
                // }
            ]
            this.teacherPaginationOption = {
                page: 1,
                pagesize: 5,
                total: 0
            }
            this.initTeacherSelect = []
            this.teacherList = []
            this.$refs.uEditor.init('')
        },
        getCourseDetails() {
            this.contentLoading = true
            getCourseDetails({code: this.params.code}).then(res => {
                this.contentLoading = false
                if (res.code === '000') {
                    this.params.code = res.data.code
                    this.params.catecode = res.data.catecode
                    this.params.catename = res.data.catename
                    this.params.summary = res.data.summary
                    this.params.name = res.data.name
                    this.params.periodcount = res.data.periodcount
                    this.params.teachercode = res.data.teachercode
                    this.params.teachername = res.data.teachername
                    this.params.content = res.data.content
                    this.params.coverattids = res.data.coverattids
                    this.params.coveratturls = res.data.coveratturls
                    this.params.ispreventrecording = res.data.ispreventrecording
                    this.params.iscopyright = res.data.iscopyright
                    this.params.isspeedplay = res.data.isspeedplay
                    this.params.status = res.data.status
                    let coverattids = this.params.coverattids.split(',')
                    let coveratturls = this.params.coveratturls.split(',')
                    let coverattArr = []
                    coverattids.forEach((item, index) => {
                        coverattArr.push({
                            coverattid: item,
                            coveratturl: coveratturls[index]
                        })
                        // this['coveratt'+(index+1)].coverattid = item
                        // this['coveratt'+(index+1)].coveratturl = coveratturls[index]
                    })
                    if (coverattArr.length < 5) {
                        coverattArr.push({
                            coverattid: '',
                            coveratturl: ''
                        })
                    }
                    this.coverattArr = JSON.parse(JSON.stringify(coverattArr))
                    if (this.params.content) {
                        this.$refs.uEditor.init(this.params.content)
                    }
                    if (this.params.teachercode) {
                        let teachercode = this.params.teachercode.split(',')
                        let teachername = this.params.teachername.split(',')
                        teachercode.forEach((item, index) => {
                            this.initTeacherSelect.push({code: item, name: teachername[index]})
                        })
                    }
                }
            })
        },
        changeCoverattArr(index) {
            this.changeCoverattArrIndex = index
        },
        coverattUploadSuccess(file) {
            let item = JSON.parse(JSON.stringify(this.coverattArr[this.changeCoverattArrIndex]))
            item.coverattid = file.key
            item.coveratturl = file.atturl
            this.$set(this.coverattArr, this.changeCoverattArrIndex, item)
            this.now = new Date().getTime()
            if ((this.changeCoverattArrIndex === this.coverattArr.length - 1 || this.coverattArr[this.coverattArr.length - 1].coveratturl) && this.coverattArr.length < 5) {
                this.coverattArr.push({
                    coverattid: '',
                    coveratturl: ''
                })
            }
            this.changeCoverattArrIndex = ''
        },
        // 移动封面图
        handleMoveCover(index, direction) {
            let index2 = ''
            if (direction === 'left') {
                index2 = index - 1
            } else if (direction === 'right') {
                index2 = index + 1
            }
            let coverattArr = JSON.parse(JSON.stringify(this.coverattArr))
            let indexItem = JSON.parse(JSON.stringify(coverattArr[index]))
            let index2Item = JSON.parse(JSON.stringify(coverattArr[index2]))
            coverattArr[index2] = indexItem
            coverattArr[index] = index2Item
            this.coverattArr = []
            this.$nextTick(() => {
                this.coverattArr = JSON.parse(JSON.stringify(coverattArr))
            })
        },
        // 删除封面图
        handleDeleteCover(index) {
            let coverattArr = JSON.parse(JSON.stringify(this.coverattArr))
            coverattArr.splice(index, 1)
            this.coverattArr = []
            this.$nextTick(() => {
                this.coverattArr = JSON.parse(JSON.stringify(coverattArr))
                if (this.coverattArr[this.coverattArr.length - 1].coverattid && this.coverattArr[this.coverattArr.length - 1].coveratturl) {
                    this.coverattArr.push({
                        coverattid: '',
                        coveratturl: ''
                    })
                }
            })
        },
        changeTeacherListPage(page) {
            this.teacherPaginationOption.page = page
            this.getCourseTeachListBySelect()
        },
        // 获取授课老师下拉列表
        getCourseTeachListBySelect() {
            let params = {
                condition: {
                    innerid: '',
                    orgname: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: this.teacherPaginationOption.page,
                pagesize: this.teacherPaginationOption.pagesize
            }
            this.teacherListLoading = true
            getCourseTeachListBySelect(params).then(res => {
                if (res.code === '000') {
                    this.teacherListLoading = false
                    this.teacherList = res.data
                    this.teacherPaginationOption.total = res.pageinfo.rowcount
                }
            })
        },
        getSelectTeacher(teacher) {
            let teachercode = []
            let teachername = []
            teacher.forEach((item) => {
                teachercode.push(item.code)
                teachername.push(item.name)
            })
            this.params.teachercode = teachercode.join(',')
            this.params.teachername = teachername.join(',')
        },
        // 获取课程详情
        getUEditorContent(content) {
            this.params.content = content
        },
        saveCourse(savetype) {
            let coverattids = []
            let coveratturls = []
            this.coverattArr.forEach(item => {
                if (item.coverattid && item.coveratturl) {
                    coverattids.push(item.coverattid)
                    coveratturls.push(item.coveratturl)
                }
            })
            coveratturls.some(item => {
                if (item) {
                    this.params.coverattids = coverattids.join(',')
                    this.params.coveratturls = coveratturls.join(',')
                    return true
                }
            })
            this.params.savetype = savetype
            this.$refs.maintainCourse.validate((valid) => {
                if (valid) {
                    if (savetype === 0) {
                        this.loading1 = true
                        this.submitDataIng = true
                    } else {
                        this.loading2 = true
                        this.submitDataIng = true
                    }
                    saveCourse(this.params).then(res => {
                        this.loading1 = false
                        this.loading2 = false
                        this.submitDataIng = false
                        if (res.code === '000') {
                            this.$message.success(res.msg)
                            this.$emit('maintainCourseSuccess', this.params.code)
                            this.handleClose()
                        }
                    })
                } else {
                    this.$message.warning('请完善您的数据')
                }
            })
        }
    },
    components: {
        UploadFile,
        UEditor,
        SelectPage
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .maintainCourse {
        .el-dialog {
            .el-dialog__body {
                .el-form {
                    .el-form-item {
                        .tips {
                            font-size: 12px;
                            color: #666666;
                            line-height: 28px;
                            position: absolute;
                            left: 80px;
                            top: -28px;
                        }
                        .uploadItemBox {
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            .uploadItem {
                                margin-right: 10px;
                                width: 80px;
                                height: 80px;
                                .noCoveratturl {
                                    cursor: pointer;
                                    width: 80px;
                                    height: 80px;
                                    background: #D9D9D9;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;
                                    .el-icon-plus {
                                        font-size: 20px;
                                        color: #fff;
                                    }
                                    .label {
                                        font-size: 12px;
                                        color: #666666;
                                        line-height: 24px;
                                    }
                                }
                                .coveratturlBox {
                                    position: relative;
                                    .coveratturl {
                                        width: 80px;
                                        height: 80px;
                                        cursor: pointer;
                                    }
                                    .coverHandleBox {
                                        width: 80px;
                                        height: 80px;
                                        background: rgba($color: #000000, $alpha: 0.2);
                                        display: none;
                                    }
                                    &:hover {
                                        .coverHandleBox {
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            i {
                                                color: #fff;
                                                &:not(:last-of-type) {
                                                    margin-right: 10px;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .countTips {
                            font-size: 12px;
                            color: #F56C6C;
                            line-height: 24px;
                        }
                    }
                    .otherItemBox {
                        .otherItem {
                            margin-bottom: 40px;
                            display: flex;
                            align-items: center;
                            .label {
                                font-size: 14px;
                                color: #666666;
                                line-height: 28px;
                                width: 180px;
                                &::before {
                                    content: '*';
                                    color: #F56C6C;
                                }
                                .el-icon-info {
                                    color: #CCCCCC;
                                    margin-left: 6px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .el-tooltip__popper.is-dark {
        color: #fff;
        background: #303133;
    }
</style>